import React from "react";
import { Form } from "@ant-design/compatible";
import "@ant-design/compatible/assets/index.css";
import { Button, Select, DatePicker, Input, Radio, Space, Popconfirm } from "antd";
import CustomDatePicker from "./CustomDatePicker";
import _ from "lodash";

const { Option } = Select;

class FormSeven extends React.Component {
  // validateIndivdualSigners = (rule, value, callback) => {
  //   const { form } = this.props;
  //   if (value && this.state.confirmDirty) {
  //     form.validateFields(['confirm'], { force: true });
  //   }
  //   callback();
  // };
  constructor() {
    super();
    this.state = { signedSigner: [], removeClear: false }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.signedSigner != this.state.signedSigner && this.state.signedSigner.length != 0) {
      this.props.form.setFieldsValue({
        indivdual_signers: this.state.signedSigner
      });
    }
    if (prevProps.postEnvelopeData != this.props.postEnvelopeData && prevState.signedSigner == this.state.signedSigner) {
      this.setState({
        signedSigner: [],
        removeClear: false
      })
    }
  }

  deleteSigners = (e) => {
    // console.log(e, "e");
    this.props.deleteSigners(e);
  };

  render() {
    const { onSubmit, form, signersGroupsGetData, postEnvelopeData, businessDate } =
      this.props;
    const { getFieldDecorator, getFieldValue } = form;

    const additionalData = {};
    additionalData.indivdual_signers = [];
    additionalData.initial_indivdual_signers = [];

    additionalData.groups = [];
    additionalData.initial_groups = {};
    additionalData.reports = [];

    if (postEnvelopeData && postEnvelopeData.reports && postEnvelopeData.length > 0 && postEnvelopeData[0].reports) {
      additionalData.reports = postEnvelopeData[0].reports;
    }

    let envelope_subject = "";
    let dateRange = "";
    if (postEnvelopeData && postEnvelopeData.length > 0 && postEnvelopeData[0].envelopeSubject) {
      if (postEnvelopeData.length > 1) {
        dateRange = postEnvelopeData[0].date + " to " + postEnvelopeData[postEnvelopeData.length - 1].date;
        envelope_subject = postEnvelopeData[0].envelopeSubject.split("for")[0] + "for " + dateRange;
      } else {
        envelope_subject = postEnvelopeData[0].envelopeSubject;
      }
    }

    let envelopId = "";
    let vendor = "";
    if (postEnvelopeData && postEnvelopeData.length > 0) {
      envelopId = postEnvelopeData[0].envelopeId;
      vendor = postEnvelopeData[0].vendor;
    }

    let envelopeSigner = _.map(postEnvelopeData, "signers");
    const signed_individual_signers = _.filter(envelopeSigner[0], function (o) { return o.signed == true });
    // console.log(signersGroupsGetData.users, "signersGroupsGetData");
    const individualUserOptions = signersGroupsGetData.users.map((d) => {
      let signers = {};
      if (postEnvelopeData && envelopeSigner) {
        signers = _.find(envelopeSigner[0], function (o) { return o.email == d.email });
      }
      return (signers && signers.signed) ?
        <Option value={d._id} key={d._id} disabled={true} >
          {d.name} - {d.user_name} - {d.email ? d.email : <b>No user email</b>}
        </Option>
        :
        <Option value={d._id} key={d._id} disabled={d.email ? false : true}>
          {d.name} - {d.user_name} - {d.email ? d.email : <b>No user email</b>}
        </Option>
    });

    const groupUserOptions = signersGroupsGetData.users.map((d) => (
      <Option value={d._id} key={d._id} disabled={d.email ? false : true}>
        {d.name} - {d.user_name} - {d.email ? d.email : <b>No user email</b>}
      </Option>
    ));

    // console.log(envelopeSigner[0], "signed_individual_signers", signed_individual_signers);
    let deletableCount = 0;
    let signedIndiviual = 0;
    if (envelopeSigner[0] && envelopeSigner[0].length != 0 && signed_individual_signers.length == 0) {
      deletableCount++;
    } else if (envelopeSigner[0] && envelopeSigner[0].length != 0 && signed_individual_signers.length != 0) {
      signedIndiviual++;
    }

    const initial_indivdual_signers = [];
    const groups_felds = [];
    if (postEnvelopeData && postEnvelopeData.length > 0) {
      postEnvelopeData.forEach((element, index) => {
        if (element.signers && element.signers.length > 0) {
          element.signers.forEach((a) => {
            const result = signersGroupsGetData.users.find((aa) => aa.email === a.email);

            if (result) {
              if (index == 0) {
                initial_indivdual_signers.push(result._id);
                additionalData.initial_indivdual_signers.push(result._id);
              }
              a.sm_id = result._id;
            }
            additionalData.indivdual_signers.push(a);
          });
        }
      });
    }

    if (postEnvelopeData && postEnvelopeData.length > 0) {
      if (postEnvelopeData[0].groups && postEnvelopeData[0].groups.length != 0) {
        deletableCount += postEnvelopeData[0].groups.length;
      }
      // let notSignedGropCount = _.filter(postEnvelopeData[0].groups, function(e){ return e.signed != true }).length;
      // if(notSignedGropCount != 0){
      //   deletableCount += notSignedGropCount;
      // }

      postEnvelopeData.forEach((element, index) => {
        if (element.groups && element.groups.length > 0) {
          element.groups.forEach((b, i) => {
            const initial_group_signers = [];
            additionalData.initial_groups[b.groupId] = [];
            if (b.signers) {
              b.signers.forEach((ba) => {
                const result = signersGroupsGetData.users.find(
                  (baa) => baa.email === ba.email
                );
                if (result) {
                  initial_group_signers.push(result._id);
                  additionalData.initial_groups[b.groupId].push(result._id);
                }
              });
            }

            additionalData.groups.push(b);

            if (index == 0) {
              groups_felds.push(
                <div key={b.groupId}>
                  <Form.Item label="Group id" style={{ display: "none" }}>
                    {getFieldDecorator(`groups[${i}].group_id`, {
                      initialValue: b.groupId,
                    })(<div></div>)}
                  </Form.Item>
                  <div key={b.groupId} className="ant-row ant-legacy-form-item">
                    {/* <Form.Item label={"Group (" + b.name + ") Signers"} key={b.groupId}> */}
                    <div className="ant-col-5 ant-legacy-form-item-label"><label>{"Group (" + b.name + ") Signers"}</label></div>
                    <div className="ant-col-18 ant-row postEnvlopeGroupinline">
                      <Form.Item className="ant-col-16">
                        {getFieldDecorator(`groups[${i}].users`, {
                          initialValue: initial_group_signers,
                          rules: [
                            {
                              required: true,
                              message: "Signers can't be empty for group",
                            },
                            // {
                            //   validator(rule, value, callback) {
                            //     if (value.length < initial_group_signers.length) {
                            //       callback("You can't remove users.");
                            //     }
                            //     callback();
                            //   },
                            // },
                          ],
                        })(
                          <Select
                            mode="multiple"
                            showSearch
                            placeholder="Select User(s)"
                            optionFilterProp="children"
                            notFoundContent={null}
                            allowClear={true}
                            disabled={b.signed}
                          >
                            {groupUserOptions}
                          </Select>
                        )}
                      </Form.Item>
                      <div className="ant-col-4 space-align-block" style={{ justifyContent: "center", marginBottom: "20px" }}>
                        {(!b.signed && (deletableCount > 1 || signedIndiviual == 1) && vendor.toLowerCase() == "docusign") ?
                          (<Space align="center">
                            <Popconfirm
                              title="Sure to delete?"
                              onConfirm={() => this.deleteSigners({ groupId: b.name })}
                            ><Button type="danger">Delete</Button>
                            </Popconfirm>
                          </Space>) : null}
                      </div>
                    </div>
                  </div>
                </div>
              );
            }
          });
        }
      });
    }

    const validateIndivdualSigners = (rule, value, callback) => {
      if (value.length == 0) {
        callback("Signers can't be empty for individual signers.");
      } else if (value.length > initial_indivdual_signers.length) {
        callback("Cannot add new signers to the envelope.");
      } else if (value.length < initial_indivdual_signers.length && vendor.toLowerCase() == "pandadoc") {
        callback("Signers cannot be removed from an active envelope. Please select a replacement signer before submitting updates.");
      }
      callback();
    }

    const onInvidualSignerChange = (e, event) => {
      let signedUserList = _.filter(envelopeSigner[0], function (o) { return o.signed });
      if (event.length === 0 && e.length === 0 && this.state.signedSigner && this.state.signedSigner.length == 0) {
        this.setState({ signedSigner: _.map(signedUserList, "sm_id"), removeClear: true });
      } else {
        this.setState({ signedSigner: [], removeClear: false });
      }
    }

    // console.log(initial_indivdual_signers, "initial_indivdual_signers");

    return (
      <Form
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 12 }}
        onSubmit={onSubmit}
      >
        <Form.Item label="Business Date">
          {getFieldDecorator("business_date")(
            // <DatePicker
            //   onChange={this.props.businessDateOnChange}
            //   style={{ width: "100%" }}
            // />
            <CustomDatePicker
              date={businessDate}
              datePickerOpen={true}
              onChangeData={this.props.businessDateOnChange}
            />
          )}
        </Form.Item>

        {(envelope_subject != "") ? (
          <Form.Item label="Envelope">
            {getFieldDecorator("envelope_subject", {
              initialValue:
                (envelope_subject != "") ? envelope_subject : null,
            })(<div> {envelope_subject}</div>)}
          </Form.Item>
        ) : null}

        {/* {postEnvelopeData && postEnvelopeData.envelope_id ? (
          <Form.Item label="Envelope ID">
            {getFieldDecorator("envelope_id", {
              initialValue:
                postEnvelopeData && postEnvelopeData.envelope_id
                  ? postEnvelopeData.envelope_id
                  : null,
            })(<div> {postEnvelopeData.envelope_id}</div>)}
          </Form.Item>
        ) : null} */}

        <Form.Item label="vendor" style={{ display: "none" }}>
          {getFieldDecorator("vendor", {
            initialValue:
              vendor ? vendor : null,
          })(<div></div>)}
        </Form.Item>

        {/* {initial_indivdual_signers.length > 0 ? ( */}
        {(initial_indivdual_signers.length != 0) ? (
          <div className="ant-row ant-legacy-form-item">
            <div className="ant-col-5 ant-legacy-form-item-label"><label>Individual Signers</label></div>
            <div className="ant-col-18 ant-row postEnvlopeGroupinline">
              <Form.Item className="ant-col-16">
                {getFieldDecorator("indivdual_signers", {
                  initialValue: initial_indivdual_signers,
                  rules: [
                    // {
                    //   required: initial_indivdual_signers.length > 0 ? true : false,
                    //   message: "Signers can't be empty for individual signers",
                    // },
                    {
                      validator: validateIndivdualSigners,
                    },
                  ],
                })(
                  <Select
                    mode="multiple"
                    showSearch
                    placeholder="Select User(s)"
                    optionFilterProp="children"
                    notFoundContent={null}
                    allowClear={true}
                    onChange={onInvidualSignerChange}
                    className={this.state.removeClear ? 'removeClear' : ''}
                  >
                    {individualUserOptions}
                  </Select>
                )}
              </Form.Item>
              <div className="ant-col-4 space-align-block" style={{ justifyContent: "center", marginBottom: "20px" }}>
                {(signed_individual_signers.length == 0 && deletableCount > 1 && vendor.toLowerCase() == "docusign") ?
                  <Space align="center">
                    <Popconfirm
                      title="Sure to delete?"
                      onConfirm={() => this.deleteSigners({ signerIds: initial_indivdual_signers })}
                    >
                      <Button type="danger">Delete</Button>
                    </Popconfirm>
                  </Space> : null}
              </div>
            </div>
          </div>
        ) : null}
        <div
          style={
            postEnvelopeData &&
              postEnvelopeData.length > 0 &&
              postEnvelopeData[0].envelope_request_id &&
              getFieldValue("indivdual_signers").length >
              additionalData.initial_indivdual_signers.length
              ? { display: "block" }
              : { display: "none" }
          }
        >
          <Form.Item label="Signature Steps">
            {getFieldDecorator("signature_steps", {
              initialValue: "1",
            })(
              <Radio.Group>
                <Radio value="1">1</Radio>
                <Radio value="2" disabled={true}>
                  2
                </Radio>
              </Radio.Group>
            )}
          </Form.Item>
        </div>
        {groups_felds}

        <Form.Item label="Individual Signers" style={{ display: "none" }}>
          {getFieldDecorator("additional_data", {
            initialValue: additionalData,
          })(<div></div>)}
        </Form.Item>

        {initial_indivdual_signers.length > 0 ||
          (postEnvelopeData &&
            postEnvelopeData.length > 0 &&
            postEnvelopeData[0].groups &&
            postEnvelopeData[0].groups.length > 0) ? (
          <Form.Item wrapperCol={{ span: 12, offset: 5 }}>
            <Button type="primary" htmlType="submit">
              Update
            </Button>
          </Form.Item>
        ) : null}
      </Form>
    );
  }
}

const WrappedApp = Form.create({ name: "form_seven" })(FormSeven);

export default WrappedApp;
